export const includesSearchIgnoreCase = (base: string, search: string) => base.toLowerCase().includes(search.toLowerCase());
